// ADDED: wraps the routes that need a session. Sends signed-out visitors to /login and
// remembers where they were headed so they land there after signing in.
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { useAuth } from './AuthProvider';

export default function ProtectedRoute({ children }) {
    const { isAuthenticated, isLoading } = useAuth();
    const location = useLocation();

    // Wait for the stored token to be checked before deciding anything
    if (isLoading) {
        return (
            // MODIFIED (styling): theme-aware, and a spinner rather than bare text
            <div className="min-h-[60vh] flex flex-col items-center justify-center gap-3">
                <span className="h-8 w-8 rounded-full border-2 border-brand-flame border-t-transparent animate-spin" />
                <p className="text-sm cv-muted">Loading...</p>
            </div>
        );
    }

    if (!isAuthenticated) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    return children;
}
